<form [formGroup]="form">
  <h6 class="mb-2">{{ label }}</h6>
  <div class="d-flex gap-3" *ngIf="!showHours; else hoursField">
    <ng-template [ngTemplateOutlet]="event"></ng-template>
    <ng-template [ngTemplateOutlet]="days"></ng-template>
  </div>

  <ng-template #hoursField>
    <ng-template [ngTemplateOutlet]="event"></ng-template>
    <div class="d-flex gap-3">
      <ng-template [ngTemplateOutlet]="days"></ng-template>
      <ng-template [ngTemplateOutlet]="hours"></ng-template>
    </div>
  </ng-template>

  <ng-template #event>
    <mat-form-field2
      class="mat-block"
      i18n-matTooltip
      matTooltip="Specify an event to set the date."
      matTooltipPosition="above"
    >
      <app-select
        [items]="rules"
        i18n-placeholder
        placeholder="Event"
        bindLabel="label"
        bindValue="type"
        [required]="form.get('base') | required"
        formControlName="base"
        [showBlankItem]="!(form.get('base') | required)"
      ></app-select>
      <mat-error *ngIf="form.get('base').hasError('required')" i18n>Event is required</mat-error>
    </mat-form-field2>
  </ng-template>
  <ng-template #days>
    <mat-form-field2
      class="mat-block"
      i18n-matTooltip
      matTooltip="Specify what to set the date w.r.t. event."
      matTooltipPosition="above"
    >
      <input type="number" matInput i18n-placeholder placeholder="Days" formControlName="days" />
      <mat-error *ngIf="form.get('days').hasError('required')" i18n>Days is required</mat-error>
      <mat-error *ngIf="form.get('days').hasError('min')" i18n>Days should be 0 at least</mat-error>
      <mat-error *ngIf="form.get('days').hasError('integer')" i18n>Days must be an integer</mat-error>
    </mat-form-field2>
  </ng-template>
  <ng-template #hours>
    <mat-form-field2
      class="mat-block"
      i18n-matTooltip
      matTooltip="Specify what to set the hour in the date w.r.t. event."
      matTooltipPosition="above"
    >
      <input type="number" matInput i18n-placeholder placeholder="Hours" formControlName="hours" />
      <mat-error *ngIf="form.get('hours').hasError('required')" i18n>Hours is required</mat-error>
      <mat-error *ngIf="form.get('hours').hasError('min')" i18n>Hours should be 0 at least</mat-error>
      <mat-error *ngIf="form.get('hours').hasError('integer')" i18n>Hours must be an integer</mat-error>
    </mat-form-field2>
  </ng-template>
</form>
